import { createBrowserHistory } from 'history'
import { URL_BASE } from '../constant'

const history = createBrowserHistory({
    basename: URL_BASE
})

export default history